module.exports = __webpack_public_path__ + "img/default.f79f1996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default.png
// module id = Lg5A
// module chunks = 1